import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { ChooseYourAIAdvisor } from "modules/personalisation/components/ChooseYourAIAdvisor/ChooseYourAIAdvisor";
import { MeetYourAIAdvisorContainer_PATH } from "modules/personalisation/containers/MeetYourAIAdvisorContainer";
import { PersonalisationAdvisorBenefitsContainer_PATH } from "modules/personalisation/containers/PersonalisationAdvisorBenefitsContainer";
import {
  Advisor,
  usePersonalisationData,
} from "modules/personalisation/context/PersonalisationDataContext";
import { usePersonalisationLeave } from "modules/personalisation/context/PersonalisationLeaveContext";

export const ChooseYourAIAdvisorContainer_PATH =
  "/personalise/choose-advisor" as const;

export function ChooseYourAIAdvisorContainer() {
  const navigate = useNavigate();
  const { advisor, setAdvisorAnswered } = usePersonalisationData();
  const { openConfirmLeave } = usePersonalisationLeave();

  const options = useMemo(
    (): Advisor[] => [
      {
        id: "adonis",
        label: "Adonis",
        avatarUrl:
          "src/modules/personalisation/assets/adonis-advisor-preferences.png",
      },
      {
        id: "aria",
        label: "Aria",
        avatarUrl:
          "src/modules/personalisation/assets/aria-advisor-preferences.png",
      },
    ],
    []
  );

  return (
    <ChooseYourAIAdvisor
      initialSelectedId={advisor.state === "answered" ? advisor.value.id : null}
      options={options}
      onContinue={(selection) => {
        if (selection) {
          setAdvisorAnswered(selection as Advisor);
        }
        navigate(MeetYourAIAdvisorContainer_PATH);
      }}
      onBack={() => navigate(PersonalisationAdvisorBenefitsContainer_PATH)}
      onClose={openConfirmLeave}
    />
  );
}
